module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_36.608a429b.png";